export const defaultData = {
	global: {
		isAccordion: true,
		isVertical: true,
		activeItems: [],
		multiple: false,
		iconEnabled: true,
		iconPosition: "right",
		activeIcon: "chevron-down-icon",
		activeIconType: "outline",
		inactiveIcon: "chevron-up-icon",
		inactiveIconType: "outline",
		activeIconClassName: "size-6",
		inactiveIconClassName: "size-6",
		labelClassName: "",
		activeLabelClassName: "",
		headerClassName: "",
		activeHeaderClassName: "",
		contentClassName: "",
		accordionClassName: "",
		tabsDefaultActive: "",
		tabsClassName: "",
		tabsLabelClassName: "",
	},
	items: [
		{
			id: "item-1",
			headerLabel: "Accordion 1",
			content: "",
			iconEnabled: true,
			iconPosition: "right",
			iconClassName: "size-6",
			activeIconClassName: "size-6",
			activeIcon: "",
			activeIconType: "",
			inactiveIcon: "",
			inactiveIconType: "",
			disabled: false,
			headerClassName: "",
			labelClassName: "",
			activeLabelClassName: "",
			activeHeaderClassName: "",
			contentClassName: "",
			accordionClassName: "",
			navigationClassName: "",
		},
	],
};
